<template>
  <div v-for="(audit, index) in auditsDataAfficher" v-bind:key="audit.cle" class="row ligne-audit-changement">
    <div class="col text-left">
      <div v-if="index === 0" class="row large-600 bold">Enregistrement courant</div>
      <div v-if="audit.dateChangement" class="row large-600 bold">Informations enregistrées le : {{
          $commun.formatDateHeure(audit.dateChangement)
        }}
      </div>      
      <div v-else class="row large-600 bold">Informations enregistrées le : {{
          $commun.formatDateHeure(suivi.creerLe)
        }}
      </div>
      <div v-if="audit.changeParEntite" class="row large-600 bold">
        Par : {{ audit.changeParEntite.nomIntervenant?.trim() }}, {{ audit.changeParEntite.prenomIntervenant?.trim() }},
        {{ audit.changeParEntite.nomGroupeSecurite?.trim() }}
      </div>
      <div v-else-if="suivi.creerParEntite" class="row large-600 erreur bold">
        Par : {{ suivi.creerParEntite.nomIntervenant?.trim() }}, {{ suivi.creerParEntite.prenomIntervenant?.trim() }}, {{ suivi.creerParEntite.nomGroupeSecurite?.trim() }}
      </div>
      <div v-else class="row large-600 erreur bold">
        Intervenant(e) inconnu(e)...
      </div>

      <div v-for="field in AUDIT_FIELDS" v-bind:key="field" class="row">
        <div class="col-5">{{ FIELD_LABELS[field] }} :</div>
        <div class="col text-center">
          <div v-if="audit[field].isModifie">{{ this.MODIFIED_ARROW }}</div>
        </div>
        <div class="col">{{ audit[field].texte }}</div>
      </div>
    </div>
  </div>

  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "TableModificationsSuivi",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("suivi/obtenirAuditsSuivisAction", {
      cle: this.$route.params.cle,
      site: this.$route.params.site,
    }).then((res) => {
      this.auditsData = res.data.entite.audits
      if (res.data.entite.audits !== null && res.data.entite.audits.length > 0) {
        this.auditsDataAfficher = this.formatterAudits(res.data.entite.audits)
      } else {
        this.auditsDataAfficher = this.formatterAucunAudit();
      }
    })
        .catch((err) => {
          this.$emit("backendError", err);
        })
        .finally(() => {
          this.$emit("isDataLoaded", true);
        });
  },
  data() {
    return {
      auditsData: [],
      auditsDataAfficher: [],
      isDataLoaded: false,
      MODIFIED_ARROW: "🢂",
      AUDIT_FIELDS: [
        "typeActiviteAfficher",
        "statutAfficher",
        "siteAfficher",
        "confidentialiteAfficher",
        "secteurAssigneAfficher",
        "intervenantAfficher",
        "prevue",
        "completee",
        "secteurCreateurAfficher",
        "creerParDescription",
        "approuverParAfficher",
        "approuverLe",
        "texte",
      ],
      FIELD_LABELS: {
        "typeActiviteAfficher": "Activité",
        "statutAfficher": "Statut",
        "siteAfficher": "Site d'origine",
        "confidentialiteAfficher": "Confidentialité",
        "secteurAssigneAfficher": "Secteur assigné",
        "intervenantAfficher": "Intervenant",
        "prevue": "Date prévue",
        "completee": "Date complétée",
        "secteurCreateurAfficher": "Secteur demandeur",
        "creerParDescription": "Demandeur",
        "approuverParAfficher": "Approbateur",
        "approuverLe": "Date d'approbation",
        "texte": "Suivi",
      },
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      suivi: "suivi/suivi",
    }),
    nombreModifications() {
      if(this.auditsData.length > 0){
        return this.auditsData.length - 1;
      }else{
        return this.auditsData.length;
      }
    },
    createur() {
      return this.suivi.creerParDescription
    },
    dateCreation() {
      return this.suivi.creerLe
    },
  },
  methods: {
    formatterAudits(listeAudits) {
      let listeAffichage = []
      let auditPrecedent = null

      // pour bâtir la diff, il faut revenir en arrière en commençant par
      // l'enregistrement le plus vieux
      listeAudits.sort((a, b) => {
        return new Date(a.dateChangement) - new Date(b.dateChangement)
      });

      // par design, on veut afficher les info actuelles dans le dernier enregistrement.
      // on pousse donc artificiellement un "audit" avec les infos actuelles du suivi
      listeAudits.push({
        "typeActiviteAfficher": this.suivi.typeActiviteAfficher,
        "statutAfficher": this.suivi.statutAfficher,
        "siteAfficher": this.suivi.siteAfficher,
        "confidentialiteAfficher": this.suivi.confidentialiteAfficher,
        "secteurAssigneAfficher": this.suivi.secteurAssigneAfficher,
        "intervenantAfficher": this.suivi.intervenantAfficher,
        "prevue": this.suivi.prevue,
        "completee": this.suivi.completee,
        "secteurCreateurAfficher": this.suivi.secteurCreateurAfficher,
        "creerParDescription": this.suivi.creerParDescription,
        "approuverParAfficher": this.suivi.approuverParAfficher,
        "approuverLe": this.suivi.approuverLe,
        "texte": this.suivi.texte,
        "changeParEntite": this.suivi.changeParEntite,
      })

      listeAudits.forEach((audit, index) => {
        let auditAffichage = {}
        this.AUDIT_FIELDS.forEach(field => {
          if (["approuverLe", "completee", "dateChangement", "prevue"].includes(field)) {
            auditAffichage[field] = {texte: this.$commun.formatDateHeure(audit[field]), isModifie: false,}
          } else {
            auditAffichage[field] = {texte: audit[field], isModifie: false,}
          }
          if (auditPrecedent
              && auditPrecedent[field].texte !== auditAffichage[field].texte) {
            auditAffichage[field].isModifie = true
          }
        })

        // pour l'affichage, il faut comprendre que les entrées de la table
        // d'audits sauvegardent l'information du véhicule _avant_ qu'il ne change.
        // autrement dit, puisqu'on commence avec creerParEntite, les informations suivantes
        // du véhicule sont une date "en retard".
        auditAffichage.changeParEntite = index === 0
            ? this.suivi.creerParEntite
            : listeAudits[index - 1].changeParEntite

        auditAffichage.dateChangement = index === 0
            ? this.suivi.creerLe
            : listeAudits[index - 1].dateChangement

        auditPrecedent = auditAffichage

        console.debug(auditAffichage)
        listeAffichage.push(auditAffichage)
      })

      // par design, la liste est affichée à partir du plus récent enregistrement.
      // pour ne pas désordonner la liste finale, dans le cas vraiment weird où la
      // date de création serait plus avancée que la date du premier audit (e.g. rapporteParDescription MMK9098),
      // on shift() le premier élément avant de filter, puis on le repousse à la fin
      let tmpAuditCreationsuivi = listeAffichage.shift()
      listeAffichage.sort((a, b) => {
        return new Date(b.dateChangement) - new Date(a.dateChangement)
      });
      listeAffichage.push(tmpAuditCreationsuivi)

      return listeAffichage
    },
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "typeActiviteAfficher": this.suivi.typeActiviteAfficher,
        "statutAfficher": this.suivi.statutAfficher,
        "siteAfficher": this.suivi.siteAfficher,
        "confidentialiteAfficher": this.suivi.confidentialiteAfficher,
        "secteurAssigneAfficher": this.suivi.secteurAssigneAfficher,
        "intervenantAfficher": this.suivi.intervenantAfficher,
        "prevue": this.suivi.prevue,
        "completee": this.suivi.completee,
        "secteurCreateurAfficher": this.suivi.secteurCreateurAfficher,
        "creerParDescription": this.suivi.creerParDescription,
        "approuverParAfficher": this.suivi.approuverParAfficher,
        "approuverLe": this.suivi.approuverLe,
        "texte": this.suivi.texte,
        "changeParEntite": this.suivi.creerParEntite,
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        if (["approuverLe", "completee", "dateChangement", "prevue"].includes(field)) {
          auditAffichage[field] = {texte: this.$commun.formatDateHeure(audit[field]), isModifie: false,}
        } else {
          auditAffichage[field] = {texte: audit[field], isModifie: false,}
        }
      })

      auditAffichage.changeParEntite = audit.changeParEntite

      listeAudits.push(auditAffichage);
      return listeAudits;
    }
  },
};
</script>